import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const DocumentDollarIcon = memo(({ className }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: 'none' }}
  >
    <rect width="35" height="35" fill="white" />
    <path
      d="M25.5208 31.5156V15.9516V4.34345C25.5208 3.56525 24.8879 2.91675 24.1285 2.91675H10.1422C9.3828 2.91675 8.74994 3.56525 8.74994 4.34345V15.9516V31.5156V32.618L9.12966 32.7477C9.25623 32.8126 9.3828 32.8126 9.50937 32.7477L10.9017 32.0992L12.2307 32.7477C12.3573 32.8126 12.4838 32.8126 12.6104 32.7477L14.0027 32.0992L15.395 32.7477C15.5216 32.8126 15.6481 32.8126 15.7747 32.7477L17.1037 32.0992L18.496 32.7477C18.6226 32.8126 18.7492 32.8126 18.8757 32.7477L20.268 32.0992L21.6603 32.7477C21.7236 32.7477 21.7869 32.8126 21.8502 32.8126C21.9135 32.8126 21.9767 32.8126 22.04 32.7477L23.4323 32.0992L24.8246 32.7477C24.9512 32.8126 25.0778 32.8126 25.2043 32.7477L25.4575 32.618V31.5156H25.5208Z"
      fill="#F0CBA7"
    />
    <path
      d="M23.8744 19.6588V30.6854"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4456 1.45837H22.9444C23.4758 1.45837 23.8744 1.85692 23.8744 2.38833V8.69871"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33447 30.619V2.38833C7.33447 1.85692 7.73302 1.45837 8.26442 1.45837H10.7222"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3236 6.57312H20.8188"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4492 9.828H17.3647"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3236 15.5405H16.5676"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3236 18.8618H16.5676"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4239 18.8618H20.8188"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3236 22.1166H16.5676"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4239 22.1166H20.8188"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4239 26.6335H20.8188"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.8743 17.4004C26.2656 17.4004 28.192 15.4741 28.192 13.0828C28.192 10.6915 26.2656 8.76514 23.8743 8.76514C21.483 8.76514 19.5567 10.6915 19.5567 13.0828C19.5567 15.4076 21.483 17.4004 23.8743 17.4004Z"
      fill="#E9F0EB"
    />
    <path
      d="M10.3236 26.6335H11.785"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.8115 14.3449C23.0772 14.6771 23.4758 14.8763 23.8743 14.8763C24.5386 14.8763 25.07 14.4778 25.07 14.0128C25.07 13.5478 24.5386 13.1493 23.8743 13.1493C23.2101 13.1493 22.6786 12.7507 22.6786 12.2858C22.6786 11.8208 23.2101 11.4222 23.8743 11.4222C24.2729 11.4222 24.6714 11.6215 24.9371 11.9536"
      stroke="#226937"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.8743 14.8099V15.4078"
      stroke="#226937"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.8743 10.6915V11.2894"
      stroke="#226937"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.8743 17.4004C26.2656 17.4004 28.192 15.4741 28.192 13.0828C28.192 10.6915 26.2656 8.76514 23.8743 8.76514C21.483 8.76514 19.5567 10.6915 19.5567 13.0828C19.5567 15.4076 21.483 17.4004 23.8743 17.4004Z"
      stroke="#226937"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.4058 30.2205L23.8744 30.4862L22.413 29.8219C22.2802 29.7555 22.1473 29.7555 22.0145 29.8219L20.5531 30.4862L19.0917 29.8219C18.9589 29.7555 18.826 29.7555 18.6932 29.8219L17.2318 30.4862L15.7705 29.8219C15.6376 29.7555 15.5048 29.7555 15.3719 29.8219L13.977 30.4862L12.5157 29.8219C12.3828 29.7555 12.25 29.7555 12.1171 29.8219L10.6558 30.4862L9.26083 29.8219C9.12798 29.7555 8.99513 29.7555 8.86228 29.8219L7.40093 30.4862L6.8031 30.154V31.2833L7.20165 31.4825C7.3345 31.549 7.46735 31.549 7.6002 31.4825L9.06155 30.8183L10.4565 31.4825C10.5893 31.549 10.7222 31.549 10.855 31.4825L12.3164 30.8183L13.7777 31.4825C13.9106 31.549 14.0434 31.549 14.1763 31.4825L15.5712 30.8183L17.0326 31.4825C17.1654 31.549 17.2983 31.549 17.4311 31.4825L18.8925 30.8183L20.3538 31.4825C20.4867 31.549 20.6195 31.549 20.7524 31.4825L22.2137 30.8183L23.6751 31.4825C23.7415 31.4825 23.8079 31.549 23.8744 31.549C23.9408 31.549 24.0072 31.549 24.0736 31.4825L24.3393 31.3497V30.2205H24.4058Z"
      fill="#EA7200"
    />
  </SvgIcon>
));
